<div class="ui-table-responsive d-none d-lg-block">
  <table class="ui-table table table-hover table-bordered mb-0" [ngClass]="tableClass">
    <thead>
      <tr>
        <th *ngFor="let column of columns" [class]="column.className || ''">{{ column.header }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; let rowIndex = index; trackBy: trackRow">
        <td *ngFor="let column of columns" [class]="column.className || ''">
          <ng-container
            *ngIf="templates[column.key]; else plainCell"
            [ngTemplateOutlet]="templates[column.key]"
            [ngTemplateOutletContext]="{ $implicit: row, row: row }"
          ></ng-container>
          <ng-template #plainCell
            ><span class="ui-table-cell-text" [attr.title]="cellValue(row, column)">{{ cellValue(row, column) }}</span></ng-template
          >
        </td>
      </tr>
      <tr *ngIf="rows.length === 0">
        <td [attr.colspan]="columns.length" class="ui-table-empty-cell">{{ emptyText }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="d-block d-lg-none ui-table-cards">
  <div *ngIf="rows.length === 0" class="ui-table-empty-mobile">{{ emptyText }}</div>
  <div class="accordion" *ngIf="rows.length > 0">
    <div class="card ui-table-card mb-2" *ngFor="let row of rows; let rowIndex = index; trackBy: trackRow">
      <div
        class="card-header d-flex align-items-center justify-content-between"
        (click)="toggleMobileCard(rowIndex)"
      >
        <strong>{{ rowTitle(row) }}</strong>
        <button
          class="btn btn-link ui-table-card-toggle"
          type="button"
          (click)="toggleMobileCard(rowIndex, $event)"
          [attr.aria-expanded]="isMobileOpen(rowIndex)"
          aria-label="Expandir o contraer registro"
        >
          <i class="bi" [ngClass]="isMobileOpen(rowIndex) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </button>
      </div>
      <div class="collapse" [class.show]="isMobileOpen(rowIndex)">
        <div class="card-body">
          <div class="ui-table-line" [class.ui-table-actions]="column.key === 'actions'" *ngFor="let column of visibleMobileColumns">
            <strong>{{ column.header }}</strong>
            <span>
              <ng-container
                *ngIf="templates[column.key]; else plainMobileCell"
                [ngTemplateOutlet]="templates[column.key]"
                [ngTemplateOutletContext]="{ $implicit: row, row: row }"
              ></ng-container>
              <ng-template #plainMobileCell>{{ cellValue(row, column) }}</ng-template>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
